/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ProductCategories from './product-categories-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ProductCategories {...validProps} />;
}
SvgComponent.iconName = 'productCategories';

export const ProductCategoriesIcon = svgIconWrapper(SvgComponent);
